import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "./App";
import RequestBike from "./RequestBike";
import Workout from "./Workout";

function Landing() {
  window.location.href = "/landing.html";
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/bike-fit-calculator" element={<App />} />
      <Route path="/request-a-bike" element={<RequestBike />} />
      <Route path="/workout" element={<Workout />} />
      <Route
        path="/transfer"
        element={<Navigate to="/bike-fit-calculator" replace />}
      />
    </Routes>
  </BrowserRouter>
);
